import { useState } from "react";
import { Accordion, Group, Paper } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { AiFillStar } from "react-icons/ai";
import AccordionFilterLabel from "../filter-components/AccordionFilterLabel";
import { NumberParam, useQueryParams } from "use-query-params";

const StarsFilter = () => {
  const isMobile = useMediaQuery("(max-width: 992px)");
  const [hover, setHover] = useState(0);
  const [query, setStars] = useQueryParams({
    stars: NumberParam,
    page: NumberParam,
  });

  return (
    <Paper
      shadow={!isMobile ? "sm" : ""}
      p={isMobile ? 0 : "xs"}
      mb={!isMobile ? 15 : ""}
      withBorder
    >
      <Accordion
        defaultValue="Aantal sterren"
        variant="filled"
        styles={{ panel: { background: "white" } }}
      >
        <Accordion.Item value="Aantal sterren">
          <Accordion.Control>
            <AccordionFilterLabel
              label={"Aantal sterren"}
              icon={AiFillStar}
              color="yellow"
            />
          </Accordion.Control>
          <Accordion.Panel>
            <Group position="center">
              {[...Array(5)].map((star, index) => {
                index += 1;
                return (
                  <button
                    type="button"
                    key={index}
                    className={`star-rating-button ${
                      index <= (query.stars || hover)
                        ? "stars-selected"
                        : "stars-unselected"
                    }`}
                    onClick={() => {
                      setStars({ stars: index, page: 1 });
                    }}
                    onMouseEnter={() => setHover(index)}
                    onMouseLeave={() => setHover(query.stars || 0)}
                  >
                    <span className="star text-2xl">&#9733;</span>
                  </button>
                );
              })}
            </Group>
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </Paper>
  );
};

export default StarsFilter;
